import { render, staticRenderFns } from "./VeStuHealthScoreSummary.vue?vue&type=template&id=aa5bce22&scoped=true"
import script from "./VeStuHealthScoreSummary.vue?vue&type=script&lang=js"
export * from "./VeStuHealthScoreSummary.vue?vue&type=script&lang=js"
import style0 from "./VeStuHealthScoreSummary.vue?vue&type=style&index=0&id=aa5bce22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5bce22",
  null
  
)

export default component.exports